<template>
  <div>
    <ModuleHeader> Creador de disponibilidad en tee sheet </ModuleHeader>
    <v-row>
      <v-col md="12" cols="12">
        Proporciona los datos requeridos para crear la disponibilidad del tee
        sheet de la actividad
      </v-col>
      <v-col md="6" cols="12">
        <v-autocomplete
          label="Actividad"
          v-model="rvaDepto"
          @input="returnDocs(rvaDepto)"
          :items="actividades"
          item-text="nm"
          item-value="id"
        ></v-autocomplete>
      </v-col>
      <v-col md="6" cols="12" v-if="!showDocs && dataDocTimes">
        <v-btn block color="error" @click="returnDocs()">
          Regresar a documentos
        </v-btn>
      </v-col>
      <v-col
        :md="dataDocTimes && dataDocTimes.Eb === true ? '6' : '6'"
        cols="12"
        v-if="!showDocs && dataDocTimes"
      >
        <v-text-field
          v-model="dataDocTimes.Dsc"
          label="Descripción"
        ></v-text-field>
      </v-col>
      <!-- <v-col
        md="2"
        cols="12"
        v-if="!showDocs && dataDocTimes && dataDocTimes.Eb !== true"
      >
        <v-switch v-model="isActive" label="Documento activo"></v-switch>
      </v-col> -->
      <v-col
        md="3"
        cols="12"
        v-if="!showDocs && dataDocTimes && !dataDocTimes.Eb"
      >
        <label>Fecha inicial</label>
        <Datepicker
          :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
          @selected="(date) => selectDate(date, 1)"
          :value="
            dataDocTimes.Rf?.fi ? dataDocTimes.Rf.fi.format('MM/DD/YYYY') : null
          "
        ></Datepicker>
      </v-col>
      <v-col
        md="3"
        cols="12"
        v-if="!showDocs && dataDocTimes && !dataDocTimes.Eb"
      >
        <label>Fecha final</label>
        <Datepicker
          :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
          @selected="(date) => selectDateFinal(date, 1)"
          :disabled-dates="disableDates"
          :value="
            dataDocTimes.Rf?.ff ? dataDocTimes.Rf.ff.format('MM/DD/YYYY') : null
          "
        ></Datepicker>
      </v-col>
      <v-col
        :md="dataDocTimes && dataDocTimes.Eb === true ? '6' : '6'"
        cols="12"
      >
        <v-btn
          v-if="!showDocs && dataDocTimes"
          block
          color="primary"
          @click="addInBlockToogle = true"
        >
          Agregar horario a todos los dias
        </v-btn>
      </v-col>
      <v-col
        v-if="!showDocs && dataDocTimes && !dataDocTimes.Eb && !newDoc"
        md="3"
        cols="12"
      >
        <v-btn
          block
          :color="dataDocTimes.Dlat ? 'success' : 'error'"
          @click="changeState(dataDocTimes.id, dataDocTimes.Dlat)"
        >
          {{ dataDocTimes.Dlat ? "Activar" : "Desactivar" }} documento
        </v-btn>
      </v-col>
      <v-col cols="12" :md="newDoc ? 6 : dataDocTimes?.Eb ? 12 : 3">
        <v-btn
          v-if="!showDocs"
          block
          color="success"
          :disabled="!newDoc && !!dataDocTimes?.Dlat"
          @click="saveDoc"
        >
          {{ newDoc ? "Crear documento" : "Guardar cambios" }}
        </v-btn>
      </v-col>

      <!-- Vista inicial documentos -->
      <v-col md="12" cols="12" v-if="showDocs">
        <v-overlay v-if="loading">Cargando documentos...</v-overlay>
        <div v-else-if="document">
          <v-container fluid>
            <v-row align="stretch">
              <v-col cols="12" sm="6" md="3">
                <!-- Añadir documentos -->
                <v-card
                  class="d-flex flex-column justify-center align-center"
                  :style="
                    document.length === 0 ? 'height: 12rem' : 'height: 100%'
                  "
                  style="cursor: pointer"
                  @click="newDocument(1)"
                >
                  <v-card-actions class="justify-center">
                    <v-icon>mdi-plus-box</v-icon>
                    <h4>Añadir documento</h4>
                  </v-card-actions>
                </v-card>
              </v-col>

              <!-- Lista de documentos -->
              <template v-for="(doc, index) in allDocuments">
                <v-col :key="index" cols="12" sm="6" md="3">
                  <!-- V-CARD DE TODOS LOS DOCUMENTOS -->
                  <v-card
                    :color="doc.eb ? 'rgba(25, 117, 209, 0.5)' : ''"
                    class="d-flex flex-column justify-space-between"
                    style="height: 100%"
                  >
                    <v-card-title class="justify-center">
                      <!-- TITULOS -->
                      <v-row>
                        <v-col md="2" cols="12">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="toggleDuplicate(doc)"
                                icon
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-content-duplicate</v-icon>
                              </v-btn>
                            </template>
                            <span>Duplicar documento</span>
                          </v-tooltip>
                        </v-col>
                        <v-col md="8" cols="12" class="text-center"
                          >{{
                            doc.eb
                              ? "Documento base"
                              : doc.fi && doc.ff
                              ? "De " + doc.inicio + " a " + doc.final
                              : "Sin rango"
                          }}
                        </v-col>
                        <v-col md="2" cols="12">
                          <!-- <v-tooltip bottom v-if="!doc.eb">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                                @click="changeState(doc.id, doc.da)"
                              >
                                <p
                                  class="my-auto"
                                  :style="
                                    doc.da ? 'color: green' : 'color: red'
                                  "
                                >
                                  {{ doc.da ? "ON" : "OFF" }}
                                </p>
                              </v-btn>
                            </template>
                            <span>{{
                              doc.da
                                ? "Activar documento"
                                : "Desactivar documento"
                            }}</span>
                          </v-tooltip> -->
                        </v-col>
                      </v-row>
                    </v-card-title>

                    <!-- CONTENIDO -->
                    <v-card-text class="text-center">
                      <v-chip
                        class="mx-1"
                        :color="
                          doc.eb
                            ? 'rgba(0, 0, 237, 0.4)'
                            : !doc.da
                            ? 'rgba(11,156,49,0.5)'
                            : 'rgba(156,11,11,0.5)'
                        "
                      >
                        {{
                          doc.eb ? "Base" : !doc.da ? "Activo" : "Desactivado"
                        }}
                      </v-chip>

                      <h4 class="mt-2">{{ doc.ds ? doc.ds : "" }}</h4>
                    </v-card-text>

                    <!-- ACCIONES -->
                    <v-card-actions>
                      <v-btn
                        elevation="0"
                        block
                        color="success"
                        @click="showDocument(doc.id)"
                        :loading="loadingButtonState[doc.id]"
                      >
                        Abrir documento
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </template>
            </v-row>
          </v-container>
        </div>
      </v-col>

      <!-- Información de los documentos -->
      <v-col md="12" cols="12" align="center" v-if="!showDocs && dataDocTimes">
        <h3>
          Horarios y precios del documento{{ dataDocTimes.Eb ? " base." : "." }}
          <!-- {{
            dataDocTimes.Fdat
              ? dataDocTimes.Fdat
              : formattedUpat(dataDocTimes.Upat)
          }} -->
        </h3>
      </v-col>
      <v-col v-if="!showDocs && dataDocTimes" md="12" cols="12">
        <template v-for="(diaData, dia) in creatorData">
          <v-list
            style="display: block; float: left; width: 14.2%"
            :key="dia"
            rounded
          >
            <v-subheader>{{ daysName[dia] }}</v-subheader>
            <v-btn v-if="false" block color="primary" small outlined> + </v-btn>
            <template v-for="(horario, indexHorarios) in diaData.horarios">
              <v-card :key="indexHorarios" class="mt-1">
                <v-btn
                  @click="deleteTime(dia, indexHorarios)"
                  x-small
                  class="btnDelete"
                  text
                  color="red"
                  >x</v-btn
                >
                <v-card-title class="mb-0 pa-2">
                  {{ horario.horario }}
                </v-card-title>
                <v-row>
                  <v-col class="py-0 text-center" md="12"
                    ><v-btn
                      @click="startEdit(dia, horario)"
                      x-small
                      outlined
                      color="success"
                      >Editar $</v-btn
                    ></v-col
                  >
                </v-row>
                <v-card-text class="px-0 pb-0 pt-3">
                  <v-expansion-panels class="mx-0 px-0 mt-0" flat>
                    <v-expansion-panel flat>
                      <v-expansion-panel-header class="px-1 py-0">
                        Precios
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="px-0 mx-0">
                        <template
                          v-for="(
                            bahiaDuracion, indexBahiaDuracion
                          ) in horario.duraciones"
                        >
                          <p
                            :key="indexBahiaDuracion"
                            class="px-n4 mt-1 mb-0"
                            style="font-size: 10px"
                          >
                            <b>{{ bahiaDuracion.BahiaName }}</b>
                          </p>
                          <table
                            :key="indexBahiaDuracion + 'table'"
                            class="px-n4 mb-0 tablePrice"
                          >
                            <tbody>
                              <thead>
                                <tr>
                                  <th
                                    style="font-size: 9px"
                                    class="text-center"
                                    width="60%"
                                  >
                                    Categoria
                                  </th>
                                  <th
                                    style="font-size: 9px"
                                    class="text-center"
                                    width="40%"
                                  >
                                    Precio
                                  </th>
                                </tr>
                              </thead>
                              <template
                                v-for="(
                                  duracion, indexduracion
                                ) in bahiaDuracion.Duraciones"
                              >
                                <tr
                                  style="
                                    border-bottom: 1px solid;
                                    border-top: 1px solid;
                                  "
                                  v-for="(
                                    precio, indexduracioprecio
                                  ) in duracion.BahiasPrecios"
                                  :key="indexduracioprecio + '' + indexduracion"
                                >
                                  <td
                                    style="font-size: 9px; line-height: initial"
                                  >
                                    {{ duracion.Duracion }} min
                                    {{ precio.ct.nm }}
                                  </td>
                                  <td
                                    style="
                                      font-size: 10px;
                                      line-height: initial;
                                    "
                                  >
                                    ${{ precio.pc.C }} {{ precio.pc.M }}
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </template>
          </v-list>
        </template>
      </v-col>
    </v-row>

    <v-dialog
      v-model="duplicateModal"
      max-width="800"
      content-class="overflow-visible"
    >
      <v-form ref="formDuplicate">
        <v-card flat>
          <v-toolbar dense dark color="primary">
            <v-btn icon dark @click="duplicateModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Duplicar documento</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col md="12" cols="12">
                <h5 class="mb-1">Descripción</h5>
                <v-textarea
                  v-model="descModal"
                  class="mb-n6"
                  rows="2"
                  label="Descripción"
                  :rules="rules.requerido"
                  dense
                  outlined
                ></v-textarea
              ></v-col>
              <v-col md="6" cols="12" v-if="input_date"
                ><h5>Fecha de inicio</h5>
                <Datepicker
                  :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
                  @selected="selectDate"
                  :value="input_date.format('MM/DD/YYYY')"
                ></Datepicker
              ></v-col>
              <v-col md="6" cols="12" v-if="input_date_final"
                ><h5>Fecha final</h5>
                <Datepicker
                  :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
                  @selected="selectDateFinal"
                  :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"
                ></Datepicker
              ></v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn @click="duplicateModal = false" color="error">Cerrar</v-btn>
            <v-btn @click="saveDocument(1)" color="success">Duplicar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="addInBlockToogle" persistent max-width="800">
      <v-form ref="formPrices">
        <v-card>
          <v-card-title class="text-h5">
            Selecciona los elementos para agregar el horario
          </v-card-title>
          <v-card-text
            >Se generara el horario en los dias seleccionados</v-card-text
          >
          <v-card-text>
            <h5>Horario y dias:</h5>
            <v-text-field
              class="mb-n4"
              label="Horario"
              :rules="rules.requerido"
              prepend-icon="mdi-clock-outline"
              v-mask="timeRangeMask"
              v-model="formDataAdd.hora"
              outlined
              dense
              required
            ></v-text-field>
            <v-switch
              v-model="formDataAdd.itsRange"
              label="Agregar como rango de horas"
            ></v-switch>
            <v-text-field
              v-if="formDataAdd.itsRange"
              class="mb-n4"
              label="intervalo de tiempo (Min)"
              prepend-icon="mdi-clock-outline"
              v-model="formDataAdd.interval"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-if="formDataAdd.itsRange"
              class="mb-n4"
              label="Horario final"
              prepend-icon="mdi-clock-outline"
              v-mask="timeRangeMask"
              v-model="formDataAdd.endHora"
              outlined
              dense
              required
            ></v-text-field>
            <template v-for="(day, index) in daysName">
              <v-checkbox
                class="mx-2"
                style="display: inline-block"
                :key="index + 'day'"
                v-model="formDataAdd.dias"
                :label="day"
                :value="index"
              ></v-checkbox>
            </template>
            <h5 class="mb-n2 mt-n1">Bahias:</h5>
            <v-alert
              border="top"
              v-if="bahias.length == 0"
              color="red lighten-2"
              dark
            >
              <v-row align="center">
                <v-col class="grow">
                  No existen bahias para esta actividad, genere algunas desde el
                  creador de bahias
                </v-col>
                <v-col class="shrink">
                  <v-btn
                    @click="$router.push({ path: '/configuracion/bahias' })"
                    >Ir a creador de bahias</v-btn
                  >
                </v-col>
              </v-row>
            </v-alert>
            <template v-for="(bahia, index) in bahias">
              <v-checkbox
                class="mx-2"
                style="display: inline-block"
                :key="index"
                v-model="formDataAdd.bahias"
                :label="bahia.nm"
                :value="bahia.id"
              ></v-checkbox>
            </template>
            <v-text-field
              class="mb-n4"
              label="Jugadores Maximos"
              prepend-icon="mdi-clock-outline"
              v-mask="'####'"
              :rules="rules.requerido"
              v-model="formDataAdd.mpl"
              outlined
              dense
              required
            ></v-text-field>
          </v-card-text>

          <v-card-text>
            <h5 class="mt-n1">Duraciones y precios:</h5>
            <v-row>
              <v-col md="6" cols="12">
                <v-text-field
                  class="mb-n4"
                  label="Duracion (min)"
                  prepend-icon="mdi-clock-outline"
                  v-mask="'###'"
                  v-model="duracionAdd"
                  outlined
                  dense
                  required
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-btn
                  color="primary"
                  @click="addDuracionesInBlock(duracionAdd)"
                  >+</v-btn
                >
              </v-col>
              <v-col md="12" cols="12">
                <template
                  v-for="(duracion, indexDuracion) in formDataAdd.duraciones"
                >
                  <v-card :key="indexDuracion">
                    <v-card-title>{{ duracion.Duracion }} Min.</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col md="6">
                          <v-row>
                            <v-col class="mt-n3" cols="12" md="6">
                              <v-autocomplete
                                v-model="dataToAdd.ct.id"
                                dense
                                :items="Categories"
                                item-text="Nombre"
                                item-value="id"
                                label="Categoria"
                              ></v-autocomplete>
                            </v-col>
                            <v-col class="mt-n3" cols="12" md="6">
                              <v-text-field
                                v-model="dataToAdd.pc.C"
                                @keypress="
                                  handleKeyPress($event, dataToAdd.pc.C)
                                "
                                label="Precio"
                                dense
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col class="mt-n3" cols="12" md="6">
                              <v-autocomplete
                                v-model="dataToAdd.pc.M"
                                :items="monedas"
                                item-text="Nombre"
                                item-value="id"
                                dense
                                label="Moneda"
                              ></v-autocomplete>
                            </v-col>
                            <v-col class="mt-n3" cols="12" md="6">
                              <v-btn
                                small
                                color="primary"
                                @click="addPrice(indexDuracion)"
                                >+</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col md="6">
                          <h5 class="text-center mt-n4">
                            Desde un paquete de precios
                          </h5>
                          <v-autocomplete
                            v-model="selectedPaquete"
                            :items="paquetesPrecio"
                            item-text="nm"
                            item-value="id"
                            class="mx-5 mt-n4"
                            label="Paquete de precios"
                          >
                            <v-btn
                              @click="migrateFromPaquete(indexDuracion)"
                              small
                              elevation="0"
                              slot="append-outer"
                              outlined
                              color="blue"
                              dark
                            >
                              <v-icon>mdi-arrow-down-bold-box</v-icon>
                            </v-btn>
                          </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-list dense>
                        <v-list-item
                          v-for="(
                            precio, indexPrecio
                          ) in duracion.BahiasPrecios"
                          :key="indexPrecio"
                        >
                          <v-row>
                            <v-col md="4" cols="12">
                              <h4 class="mt-4">
                                {{ precio.ct.nm }}
                              </h4>
                            </v-col>
                            <v-col md="4" cols="12">
                              <v-text-field
                                v-model="precio.pc.C"
                                @keypress="handleKeyPress($event, precio.pc.C)"
                                label="Precio"
                              ></v-text-field>
                            </v-col>
                            <v-col md="4" cols="12">
                              <v-btn
                                small
                                class="mt-4"
                                color="red"
                                @click="deletePrice(indexDuracion, indexPrecio)"
                                dark
                                ><v-icon>mdi mdi-delete</v-icon></v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              text
              @click="
                cleanOnCancel();
                addInBlockToogle = false;
              "
            >
              Cancelar
            </v-btn>
            <v-btn color="green darken-1" text @click="verifyAddMode()">
              Agregar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="editPriceToogle" max-width="800">
      <EditorTimes
        @applyChange="applyChange"
        @cancel="editPriceToogle = false"
        :key="formEditKey"
        :activity="rvaDepto"
        :actividades="actividades"
        :bahias="bahias"
        :dataEdit="dataEdit"
        :familias="Familias"
      ></EditorTimes>
    </v-dialog>
  </div>
</template>

<script>
import EditorTimes from "./EditorTimes.vue";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import Vue from "vue";
import Datepicker from "vuejs-datepicker";
export default {
  name: "TimesCreator",
  components: { EditorTimes, Datepicker },
  props: [],
  data() {
    return {
      rules: {
        requerido: [(value) => !!value || "El campo es obligatorio"],
      },
      formEditKey: 0,
      dataEdit: null,
      paquetesPrecio: [],
      Categories: [],
      actividades: [],
      tab: 0,
      addInBlockToogle: false,
      editPriceToogle: false,
      formDataAdd: {
        hora: "00:00",
        itsRange: false,
        endHora: "18:00",
        interval: 60,
        mpl: 4,
        dias: [],
        bahias: [],
        duraciones: [],
      },
      dataToAdd: {
        fmi: "",
        fmn: "",
        mpl: 4,
        ct: { id: "", nm: "" },
        pc: { C: 0, M: this.$Currencies.getCurrencyDefault() },
      },
      duracionAdd: 60,
      selectedPaquete: null,
      creatorData: {
        0: { horarios: [] },
        1: { horarios: [] },
        2: { horarios: [] },
        3: { horarios: [] },
        4: { horarios: [] },
        5: { horarios: [] },
        6: { horarios: [] },
      },
      daysName: [
        "Domingo",
        "Lunes",
        "Martes",
        "Miercoles",
        "Jueves",
        "Viernes",
        "Sabado",
      ],
      editing: false,
      rvaDepto: null,
      dataDocTimes: null,
      // dataDocTimes: {
      //   Crat: null,
      //   Iact: "",
      //   Times: {},
      //   Upat: null,
      // },
      dias: [],
      bahias: [],
      Familias: [],

      document: [],
      allDocuments: [],
      loading: false,
      showDocs: false,
      loadingButtonState: {},

      dupeModalKey: 1,
      duplicateModal: false,
      descModal: "",
      input_date: null,
      input_date_final: null,
      refreshKey: 0,

      newDoc: false,
    };
  },
  methods: {
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    handleKeyPress(event, target) {
      this.$pgsHelper.onlyNumber(event, target);
    },
    deleteTime(indexDia, indexHorario) {
      this.creatorData[indexDia].horarios.splice(indexHorario, 1);
    },
    cleanOnCancel() {
      this.formDataAdd = {
        hora: "00:00",
        dias: [],
        bahias: [],
        duraciones: [],
        mpl: 4,
        itsRange: false,
        endHora: "18:00",
        interval: 60,
      };
    },
    applyChange(data) {
      let existHora = this.$pgsHelper.getById(
        this.creatorData[data.dia].horarios,
        "horario",
        data.horario
      );
      if (existHora) {
        this.creatorData[Number(data.dia)].horarios[existHora.idx] = data;
        this.editPriceToogle = false;
      }
    },
    startEdit(dia, horario) {
      let dataEdit = {
        dia: dia,
        ...this.$pgsHelper.cloneObj(horario),
      };
      this.dataEdit = dataEdit;
      this.formEditKey++;
      this.editPriceToogle = true;
    },
    getBahiaNameById(id) {
      let exist = this.$pgsHelper.getById(this.bahias, "id", id);
      if (exist) {
        return exist.nm;
      } else {
        return "---";
      }
    },
    migrateFromPaquete(indexDuracion) {
      let paquete = this.$pgsHelper.getById(
        this.paquetesPrecio,
        "id",
        this.selectedPaquete
      );
      if (paquete) {
        paquete.ps.forEach((precio) => {
          let exist = false;
          let indice = 0;
          this.formDataAdd.duraciones[indexDuracion].BahiasPrecios.forEach(
            (pre, index) => {
              if (pre.ct.id == precio.ct.id) {
                exist = true;
                indice = index;
              }
            }
          );

          if (!exist) {
            precio.fmi = this.getCategoriaById(precio.ct.id).Familia;
            precio.fmn = this.getFamiliasById(
              this.getCategoriaById(precio.ct.id)?.Familia
            ).text;
            precio.mpl = Number(this.formDataAdd.mpl);
            precio.ct.nm = this.getCategoriaById(precio.ct.id).Nombre;
            precio.pc.C = Number(precio.pc.C);
            this.formDataAdd.duraciones[indexDuracion].BahiasPrecios.push(
              this.$pgsHelper.cloneObj(precio)
            );
          } else {
            precio.fmi = this.getCategoriaById(precio.ct.id).Familia;
            precio.fmn = this.getFamiliasById(
              this.getCategoriaById(precio.ct.id)?.Familia
            ).text;
            precio.mpl = Number(this.formDataAdd.mpl);
            precio.ct.nm = this.getCategoriaById(precio.ct.id).Nombre;
            precio.pc.C = Number(precio.pc.C);
            this.formDataAdd.duraciones[indexDuracion].BahiasPrecios[indice] =
              this.$pgsHelper.cloneObj(precio);
          }
        });
      }
    },
    addDuracionesInBlock(duracion) {
      let existDuration = this.$pgsHelper.getById(
        this.formDataAdd.duraciones,
        "Duracion",
        duracion
      );
      if (!existDuration) {
        this.formDataAdd.duraciones.push({
          Duracion: duracion,
          BahiasPrecios: [],
        });
      }
    },
    async getBahias() {
      let bahias = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "ACT/Bahias"
        );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          if (element[1].ia == this.rvaDepto) {
            bahias.push({ id: element[0], ...element[1] });
          }
        });
      }
      bahias = this.$_.orderBy(bahias, "od", "asc");
      this.bahias = bahias;
    },
    verifyAddMode() {
      if (this.$refs.formPrices.validate()) {
        if (this.formDataAdd.itsRange) {
          this.addTimeInBlockByRange();
        } else {
          this.addTimeInBlock();
        }
      }
    },
    addTimeInBlock(hora = null) {
      this.formDataAdd.dias.forEach((dia) => {
        if (!this.creatorData[dia].horarios) {
          this.creatorData[dia].horarios = [];
        }
        let processedDuraciones = [];
        //Procesar bahias y duraciones
        this.formDataAdd.bahias.forEach((bahia) => {
          let bahiaName = "";
          let bahiaExist = this.$pgsHelper.getById(this.bahias, "id", bahia);
          if (bahiaExist) {
            bahiaName = bahiaExist.nm;
          }
          processedDuraciones.push({
            Bahia: bahia,
            BahiaName: bahiaName,
            Duraciones: this.formDataAdd.duraciones,
          });
        });
        let obj = {
          horario: hora ? hora : this.formDataAdd.hora,
          bahias: this.formDataAdd.bahias,
          duraciones: processedDuraciones,
        };
        //verificar si existe horario
        let existHorario = this.$pgsHelper.getById(
          this.creatorData[dia].horarios,
          "horario",
          obj.horario
        );
        if (existHorario) {
          //si existe
          //verificar por cada duracion a agregar si ya existe en el horarios
          obj.duraciones.forEach((dur) => {
            let existBahiaInHorario = this.$pgsHelper.getById(
              this.creatorData[dia].horarios[existHorario.idx].duraciones,
              "Bahia",
              dur.Bahia
            );
            if (existBahiaInHorario) {
              //si existe informacion de la bahia dentro los precio
              //por cada duracion dentro de la bahia verificar si existe
              dur.Duraciones.forEach((precioDuracion) => {
                let existDuracion = this.$pgsHelper.getById(
                  this.creatorData[dia].horarios[existHorario.idx].duraciones[
                    existBahiaInHorario.idx
                  ].Duraciones,
                  "Duracion",
                  precioDuracion.Duracion
                );
                if (existDuracion) {
                  precioDuracion.BahiasPrecios.forEach((precio) => {
                    let existPrecio = false;
                    let indexFind = 0;
                    this.creatorData[dia].horarios[existHorario.idx].duraciones[
                      existBahiaInHorario.idx
                    ].Duraciones[existDuracion.idx].BahiasPrecios.forEach(
                      (pre, indexPrecio) => {
                        if (pre.ct.id == precio.ct.id) {
                          existPrecio = true;
                          indexFind = indexPrecio;
                        }
                      }
                    );

                    if (!existPrecio) {
                      this.creatorData[dia].horarios[
                        existHorario.idx
                      ].duraciones[existBahiaInHorario.idx].Duraciones[
                        existDuracion.idx
                      ].BahiasPrecios.push(precio);
                    } else {
                      this.creatorData[dia].horarios[
                        existHorario.idx
                      ].duraciones[existBahiaInHorario.idx].Duraciones[
                        existDuracion.idx
                      ].BahiasPrecios[indexFind] = precio;
                    }
                  });
                } else {
                  this.creatorData[dia].horarios[existHorario.idx].duraciones[
                    existBahiaInHorario.idx
                  ].Duraciones.push(precioDuracion);
                }
              });
            } else {
              this.creatorData[dia].horarios[existHorario.idx].duraciones.push(
                dur
              );
            }
          });
        } else {
          this.creatorData[dia].horarios.push(obj);
        }
      });
      let doc = this.parseFormToDoc();
      doc.Times = this.OrderData(doc);
      this.dataDocTimes = doc;
      this.parseDocToForm(this.$pgsHelper.cloneObj(doc));
      if (!hora) {
        this.formDataAdd = {
          hora: "00:00",
          itsRange: false,
          endHora: "18:00",
          interval: 60,
          dias: [],
          bahias: [],
          duraciones: [],
        };
      }

      this.addInBlockToogle = false;
    },
    addTimeInBlockByRange() {
      let initTim = new moment(this.formDataAdd.hora, "HH:mm");
      let endTime = new moment(this.formDataAdd.endHora, "HH:mm");
      let auxDate = initTim;
      for (
        let i = 0;
        auxDate.format("HH:mm") <= endTime.format("HH:mm") &&
        auxDate.format("YYYY-MM-DD") == endTime.format("YYYY-MM-DD");
        i++
      ) {
        this.addTimeInBlock(auxDate.format("HH:mm"));
        auxDate = auxDate.add(Number(this.formDataAdd.interval), "minutes");
      }
      this.formDataAdd = {
        hora: "00:00",
        itsRange: false,
        endHora: "18:00",
        interval: 60,
        mpl: 4,
        dias: [],
        bahias: [],
        duraciones: [],
      };
      this.addInBlockToogle = false;
    },
    deletePrice(indexDuracion, indexPrecio) {
      this.formDataAdd.duraciones[indexDuracion].BahiasPrecios.splice(
        indexPrecio,
        1
      );
    },
    addPrice(indexToAdd) {
      let exist = false;
      this.formDataAdd.duraciones[indexToAdd].BahiasPrecios.forEach((pre) => {
        if (pre.ct.id == this.dataToAdd.ct.id) {
          exist = true;
        }
      });
      if (!exist) {
        this.dataToAdd.fmi = this.getCategoriaById(
          this.dataToAdd.ct.id
        ).Familia;
        this.dataToAdd.mpl = Number(this.formDataAdd.mpl);
        this.dataToAdd.fmn = this.getFamiliasById(
          this.getCategoriaById(this.dataToAdd.ct.id)?.Familia
        ).text;
        this.dataToAdd.ct.nm = this.getCategoriaById(
          this.dataToAdd.ct.id
        ).Nombre;
        this.dataToAdd.pc.C = Number(this.dataToAdd.pc.C);
        this.formDataAdd.duraciones[indexToAdd].BahiasPrecios.push(
          this.$pgsHelper.cloneObj(this.dataToAdd)
        );
      }
    },
    getCategoriaById(id) {
      let exist = this.$pgsHelper.getById(this.Categories, "id", id);
      if (exist) {
        return exist;
      } else {
        return "Categoria no valida";
      }
    },
    getFamiliasById(id) {
      let exist = this.$pgsHelper.getById(this.Familias, "value", id);
      if (exist) {
        return exist;
      } else {
        return "Categoria no valida";
      }
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );
      let arrayFam = this.$pgsHelper.ArrayObjectToArray(data.val());
      let familias = [];
      arrayFam.forEach(function (element) {
        familias.push({ value: element.id, text: element.Nombre });
      });
      this.Familias = familias;
    },
    timeMask(value) {
      const hours = [/[0-2]/, value.charAt(0) === "2" ? /[0-3]/ : /[0-9]/];
      const minutes = [/[0-5]/, /[0-9]/];
      return value.length > 2 ? [...hours, ":", ...minutes] : hours;
    },
    timeRangeMask(value) {
      const numbers = value.replace(/[^0-9]/g, "");
      if (numbers.length > 4) {
        return [
          ...this.timeMask(numbers.substring(0, 4)),
          "-",
          ...this.timeMask(numbers.substring(4)),
        ];
      }
      return [...this.timeMask(numbers)];
    },
    // formattedUpat(upat) {
    //   if (upat) {
    //     return moment(upat).format("YYYY/MM/DD");
    //   } else return "Nueva fecha";
    // },
    async getAllDocuments() {
      this.showDocs = true;
      const database = this.$store.getters.getFirebaseApp.database;
      let snapshot = await database.queryBuilder("ACT/Timesheets", [
        database.orderByChild("ia"),
        database.equalTo(this.rvaDepto),
      ]);
      if (snapshot.exists()) {
        this.loading = true;
        this.allDocuments = [];

        let arrayDocuments = snapshot.val();

        Object.entries(arrayDocuments).forEach(([index, element]) => {
          this.allDocuments.push({
            id: index,
            createdAt: moment(element.ca).format("YYYY-MM-DD"),
            inicio: element.fi ? moment(element.fi).format("YYYY-MM-DD") : null,
            final: element.ff ? moment(element.ff).format("YYYY-MM-DD") : null,
            ...element,
          });
        });

        this.allDocuments.sort((a, b) => {
          if (a.eb === true && b.eb === false) return -1;
          if (a.eb === false && b.eb === true) return 1;

          return a.ca - b.ca;
        });
        // console.log("allDocuments", this.allDocuments);
      } else {
        this.allDocuments = [];
      }
      this.loading = false;
    },
    async getInfoDocTimes(id) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;

      const doc = await firestore.doc("ACT_Timesheets/", id);

      const data = await firestore.getDoc(doc);

      let documents = { id: data.ref.id, ...data.data() };

      this.document = documents;
      // console.log("docs",this.document)

      // console.log("document", this.document);
    },
    async showDocument(index) {
      this.$set(this.loadingButtonState, index, true);
      if (index) {
        await this.getInfoDocTimes(index);
        this.dataDocTimes = {
          Crat: null,
          RVAD: "",
          Times: {},
          Upat: null,
          Dsc: null,
          Rf: {
            ff: new moment(),
            fi: new moment(),
          },
        };
        let dataDocTimes = this.document;
        dataDocTimes.Times = this.OrderData(dataDocTimes);
        this.dataDocTimes = dataDocTimes;
        if (!this.dataDocTimes.Rf) {
          //this.dataDocTimes.sinRango = true;
          this.dataDocTimes.Rf = {
            ff: new moment(),
            fi: new moment(),
          };
        } else {
          this.dataDocTimes.Rf = {
            ff: moment(this.dataDocTimes.Rf.ff),
            fi: moment(this.dataDocTimes.Rf.fi),
          };
        }
        this.parseDocToForm(this.$pgsHelper.cloneObj(dataDocTimes));
        this.newDoc = false;
      } else {
        this.newDocument();
      }
      this.$set(this.loadingButtonState, index, false);
      this.showDocs = false;
    },
    newDocument(nuevo = 0) {
      this.dias = [];
      this.dataDocTimes = {
        Crat: null,
        RVAD: "",
        Times: {},
        Upat: null,
        Dsc: "",
        Rf: {
          ff: new moment(),
          fi: new moment(),
        },
      };
      this.creatorData = {
        0: {},
        1: { horarios: [] },
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
      };
      if (nuevo == 1) {
        this.showDocs = false;
        this.newDoc = true;
      }
    },
    async toggleDuplicate(doc) {
      this.descModal = null;
      this.dupeModalKey++;
      await this.getInfoDocTimes(doc.id);
      let dataDocTimes = this.document;
      dataDocTimes.Times = this.OrderData(dataDocTimes);
      this.dataDocTimes = dataDocTimes;
      // console.log("datadoctimes", this.dataDocTimes);
      this.input_date = this.dataDocTimes.Rf
        ? moment(this.dataDocTimes.Rf.fi)
        : new moment();
      this.input_date_final = this.dataDocTimes.Rf
        ? moment(this.dataDocTimes.Rf.ff)
        : new moment();
      this.parseDocToForm(this.$pgsHelper.cloneObj(dataDocTimes));
      this.duplicateModal = true;
    },
    returnDocs(update = null) {
      if (update && !this.dataDocTimes) {
        this.getBahias();
        this.getPaquetesPrecio();
        this.getAllDocuments();
        this.dataDocTimes = null;
        return;
      }
      if (update && this.dataDocTimes) {
        const act = this.$pgsHelper.getById(this.actividades, "id", update);
        Vue.prototype
          .$swal({
            title: `¿Desea cambiar a ${act ? act.nm : "otra actividad"}?`,
            text: "Perderá todo cambio no guardado",
            icon: "question",
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#a9a5a5",
            confirmButtonText: "Regresar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.getBahias();
              this.getPaquetesPrecio();
              this.getAllDocuments();
              this.dataDocTimes = null;
            }
          });
        return;
      }
      Vue.prototype
        .$swal({
          title: "¿Desea regresar a documentos?",
          text: "Perderá todo cambio no guardado",
          icon: "question",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#a9a5a5",
          confirmButtonText: "Regresar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.showDocs = true;
            this.dataDocTimes = null;
          }
        });
    },
    parseDocToForm(doc) {
      let dataForm = {};
      if (doc.Times) {
        let diasArray = Object.entries(doc.Times);
        diasArray.forEach((dia) => {
          dataForm[dia[0]] = { horarios: [] };
          let horarios = dia[1];
          let horariosArray = Object.entries(
            this.$pgsHelper.cloneObj(horarios)
          );
          horariosArray.forEach((horario) => {
            dataForm[dia[0]].horarios.push({
              horario: horario[0],
              bahias: [],
              duraciones: [],
            });
            let bahias = horario[1];
            let bahiasArray = Object.entries(this.$pgsHelper.cloneObj(bahias));
            bahiasArray.forEach((bahia) => {
              let existHorario = this.$pgsHelper.getById(
                dataForm[dia[0]].horarios,
                "horario",
                horario[0]
              );
              if (existHorario) {
                dataForm[dia[0]].horarios[existHorario.idx].duraciones.push({
                  Bahia: bahia[0],
                  BahiaName: bahia[1].bnm,
                  Duraciones: [],
                });
              }
              let duraciones = bahia[1].dcs;
              let duracionesArray = Object.entries(
                this.$pgsHelper.cloneObj(duraciones)
              );
              duracionesArray.forEach((duracion) => {
                let existBahia = this.$pgsHelper.getById(
                  dataForm[dia[0]].horarios[existHorario.idx].duraciones,
                  "Bahia",
                  bahia[0]
                );
                if (existBahia) {
                  dataForm[dia[0]].horarios[existHorario.idx].duraciones[
                    existBahia.idx
                  ].Duraciones.push({
                    Duracion: duracion[0],
                    BahiasPrecios: [],
                  });
                }
                let precios = duracion[1];
                let preciosArray = Object.entries(
                  this.$pgsHelper.cloneObj(precios)
                );
                preciosArray.forEach((precio) => {
                  let existDuracion = this.$pgsHelper.getById(
                    dataForm[dia[0]].horarios[existHorario.idx].duraciones[
                      existBahia.idx
                    ].Duraciones,
                    "Duracion",
                    duracion[0]
                  );
                  if (existDuracion) {
                    precio[1].pco.C = Number(precio[1].pco.C);
                    dataForm[dia[0]].horarios[existHorario.idx].duraciones[
                      existBahia.idx
                    ].Duraciones[existDuracion.idx].BahiasPrecios.push({
                      fmi: precio[1].fmi,
                      mpl: precio[1].mpl,
                      fmn: precio[1].fmn,
                      ct: {
                        id: precio[0],
                        nm: precio[1].cnm,
                      },
                      pc: precio[1].pco,
                    });
                  }
                });
              });
            });
          });
        });
      }
      this.creatorData = dataForm;
    },
    parseFormToDoc() {
      let docData = {};
      let dias = Object.entries(this.creatorData);
      dias.forEach((dia) => {
        docData[dia[0]] = {};
        dia[1]?.horarios?.forEach((horario) => {
          docData[dia[0]][horario.horario] = {};
          horario.duraciones.forEach((bahia) => {
            docData[dia[0]][horario.horario][bahia.Bahia] = {
              bnm: bahia.BahiaName,
              dcs: {},
            };
            bahia.Duraciones.forEach((duracion) => {
              docData[dia[0]][horario.horario][bahia.Bahia].dcs[
                duracion.Duracion
              ] = {};
              duracion.BahiasPrecios.forEach((precio) => {
                //precio.pc = Number(precio.pc)
                docData[dia[0]][horario.horario][bahia.Bahia].dcs[
                  duracion.Duracion
                ][precio.ct.id] = {
                  cnm: precio.ct.nm,
                  fmi: precio.fmi,
                  mpl: precio.mpl,
                  fmn: precio.fmn,
                  pco: precio.pc,
                };
              });
            });
          });
        });
      });
      this.dataDocTimes.Times = docData;
      return this.dataDocTimes;
    },
    selectDate(arg, type = 0) {
      if (type == 1) {
        this.dataDocTimes.Rf.fi = moment(arg);
        // .toDate();
      } else {
        this.input_date = moment(arg);
        // .toDate();
      }
      this.refreshKey++;

      // this.input_date_final = moment(arg);
    },
    selectDateFinal(arg, type = 0) {
      if (type == 1) {
        this.dataDocTimes.Rf.ff = moment(arg);
        // .toDate();
      } else {
        this.input_date_final = moment(arg);
        // .toDate();
      }
    },
    OrderData(doc) {
      if (doc.Times) {
        let times = {};
        let diasArray = Object.entries(doc.Times);
        diasArray.forEach((day) => {
          let OrderHorarios = this.orderHorarios(day[1]);
          //dias.push({ day: day[0], Horarios: OrderHorarios });
          times[day[0]] = OrderHorarios;
        });
        return times;
      }
    },
    orderHorarios(horarios) {
      let horariosArray = Object.entries(horarios);

      let orderTime = this.$_.orderBy(horariosArray, "0", "asc");
      let orderenTimes = {};
      orderTime.forEach((time) => {
        orderenTimes[time[0]] = this.orderBahias(
          this.$pgsHelper.cloneObj(time[1])
        );
      });
      return orderenTimes;
    },
    orderBahias(bahias) {
      let bahiasArray = this.$pgsHelper.ArrayObjectToArray(bahias);
      bahiasArray.forEach((bahia) => {
        let existBahia = this.$pgsHelper.getById(this.bahias, "id", bahia.id);
        bahia.od = existBahia.od;
      });
      let orderBahia = this.$_.orderBy(bahiasArray, "od", "asc");
      let orderenBahias = {};
      orderBahia.forEach((bahia) => {
        let orderedDuraciones = this.orderDuraciones(
          this.$pgsHelper.cloneObj(bahia.dcs)
        );
        bahia.dcs = orderedDuraciones;
        orderenBahias[bahia.id] = bahia;
      });
      return orderenBahias;
    },
    orderDuraciones(duraciones) {
      let duracionesArray = Object.entries(duraciones);
      duracionesArray = this.$_.orderBy(duracionesArray, "0", "asc");
      let orderenDuracion = {};
      duracionesArray.forEach((duracion) => {
        orderenDuracion[duracion[0]] = duracion[1];
      });
      return orderenDuracion;
    },
    async getActividades() {
      let actividades = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "ACT/Actividades"
        );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          actividades.push({ id: element[0], ...element[1] });
        });
        this.actividades = actividades;
      } else {
        this.actividades = [];
      }
    },
    async getPaquetesPrecio() {
      let paquetes = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "ACT/Paquetes"
        );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          if (element[1].ia == this.rvaDepto) {
            paquetes.push({ id: element[0], ...element[1] });
          }
        });
      }
      this.paquetesPrecio = paquetes;
    },
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
    async changeState(id, da) {
      const hasArg = da !== null;
      const verb = hasArg ? "activar" : "desactivar";
      const mayus = verb[0].toUpperCase() + verb.slice(1);

      console.log("changeState", hasArg);

      this.$swal({
        title: `¿Desea ${verb} el documento?`,
        text: `Se ${verb}á el documento`,
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: mayus,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = {};
          return await this.$store.getters.getFirebaseApp.fba
            .call("ACT-Timesheets-changestateTimesheet", {
              Id: id,
              Estado: hasArg,
            })
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento desactivado",
              "El documento se desactivó correctamente",
              "success"
            );
            this.getAllDocuments();
          } else {
            this.$swal("Error al desactivar", result.value.data.error, "error");
          }
        }
      });
    },
    saveDoc() {
      let data = this.parseFormToDoc();
      if (data.id) {
        this.editDocument();
      } else {
        this.saveDocument();
      }
    },
    async saveDocument(isDupe = 0) {
      if (isDupe == 1) {
        if (this.$refs.formDuplicate.validate()) {
          let data = this.parseFormToDoc();
          let dataToSend = {
            Crat: null,
            Iact: this.rvaDepto,
            RVAD: "",
            Times: data.Times,
            Upat: null,
            Dsc: this.descModal,
            Rf: {
              fi: moment(this.input_date).format("YYYY-MM-DD"),
              ff: moment(this.input_date_final).format("YYYY-MM-DD"),
            },
          };

          // console.log(data, dataToSend);
          this.$alert.alertConfirm({
            action: "crear",
            obj: "el documento de horarios",
            route: "ACT-Timesheets-createTimesheet",
            data: dataToSend,
            onSuccess: () => {
              this.getAllDocuments();
              this.duplicateModal = false;
            },
          });
        }
      } else {
        let data = this.parseFormToDoc();
        // const da = this.isActive ? null : new moment().format("YYYY-MM-DD");
        let dataToSend = {
          Crat: data.Crat,
          Iact: this.rvaDepto,
          RVAD: data.RVAD,
          Times: data.Times,
          Rf: {
            ff: moment(this.dataDocTimes.Rf.ff).format("YYYY-MM-DD"),
            fi: moment(this.dataDocTimes.Rf.fi).format("YYYY-MM-DD"),
          },
          Upat: data.Upat,
          Dsc: data.Dsc,
        };
        // if (da) {
        //   dataToSend.da = da;
        // }
        this.$alert.alertConfirm({
          action: "crear",
          obj: "el documento de horarios",
          route: "ACT-Timesheets-createTimesheet",
          data: dataToSend,
          onSuccess: () => {
            this.getAllDocuments();
          },
        });
      }
    },
    async editDocument() {
      let data = this.parseFormToDoc();
      data.Id = data.id;
      // const da = this.isActive ? null : new moment().format("YYYY-MM-DD");
      let dataToSend = {
        Id: data.id,
        Crat: data.Crat,
        Iact: this.rvaDepto,
        RVAD: data.RVAD,
        Times: data.Times,
        Upat: data.Upat,
        Dsc: data.Dsc,
      };
      if (!data.Eb) {
        dataToSend.Rf = {
          ff: moment(this.dataDocTimes.Rf.ff).format("YYYY-MM-DD"),
          fi: moment(this.dataDocTimes.Rf.fi).format("YYYY-MM-DD"),
        };
      }
      this.$alert.alertConfirm({
        action: "editar",
        obj: "el documento de horarios",
        route: "ACT-Timesheets-updateTimesheet",
        data: dataToSend,
        onSuccess: async () => {
          await this.getAllDocuments();
        },
      });
    },
  },
  computed: {
    ...mapGetters(["getPDVMonedasLista"]),
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    monedas() { 
      let monedas = [];
      this.getPDVMonedasLista.forEach((moneda) => {
        monedas.push(moneda);
      });
      return monedas;
    },
    departamentos() {
      let deptos = [];
      let departamentos = this.$store.getters.getDepartamentos;
      departamentos.forEach((dep) => {
        if (dep.id != "Golf") {
          (dep.text = dep.Nombre), (dep.value = dep.id);
          deptos.push(dep);
        }
      });
      return deptos;
    },
    disableDates() {
      this.refreshKey;
      // Prioriza la fecha almacenada en input_date o la que viene del documento
      const fechaInicial = this.input_date || this.dataDocTimes.Rf?.fi;
      // Si no hay una fecha válida, retorna un objeto vacío o lo que espere el datepicker
      if (!fechaInicial) {
        return {};
      }
      return { to: moment(fechaInicial).toDate() };
    },
    // isActive() {
    //   return !this.dataDocTimes.da;
    // },
  },
  watch: {},
  mounted() {
    this.getActividades();
    this.getCategories();
    this.getFamilias();
    /*if (this.$route.params.idDocument) {
      this.getInfoDocTimes(this.$route.params.idDocument)
    }*/
    //this.getInfoDocTimes()
    // this.getAllDocuments()
  },
  created() {},
};
</script>
<style scope>
.v-expansion-panel-content__wrap {
  padding: 0 7px 16px;
}
.tablePrice {
  width: 100%;
}
.btnDelete {
  position: absolute;
  right: 0;
}
.dateinputClass {
  border: 1px solid gray !important;
  border-radius: 4px !important;
}
</style>
